<template>
  <div v-loading="loading" class="ensure-income-list-container">
    <div class="head flex-align-center">
      <div style="display: flex;align-items: center;">
        <el-form :model="query" size="mini" inline>
          <el-form-item>
            <el-date-picker style="width: 240px" v-model="query.date_range" type="monthrange" align="right"
              size="mini" format="yyyy年MM月" value-format="yyyy-MM" unlink-panels range-separator="至"
              start-placeholder="开始月份" end-placeholder="结束月份" :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-date-picker v-model="query.date_check" type="month" format="yyyy年MM月" value-format="yyyy-MM"
              placeholder="搜索月份" style="width: 130px" size="mini" @change="handleSearch" />
          </el-form-item>
          <el-form-item>
            <el-input v-model="query.brand" placeholder="品牌" @change="handleSearch" clearable />
          </el-form-item>
          <el-form-item>
            <select-artist :value.sync="query.artist_id" size="mini" @change="handleSearch" />
          </el-form-item>
          <el-form-item>
            <el-input v-model="query.agent_name" placeholder="经纪人" clearable/>
          </el-form-item>
          <el-form-item>
            <company-select :company-id.sync="query.company_id" @selected="handleSearch" />
          </el-form-item>
          <el-form-item>
            <el-select style="width: 100px" v-model="query.is_notify" placeholder="通知状态" clearable
                       @change="handleSearch" size="mini">
              <el-option label="已通知" value="Y"></el-option>
              <el-option label="未通知" value="N"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select style="width: 100px" v-model="query.is_confirm" placeholder="确认状态" clearable
                       @change="handleSearch" size="mini">
              <el-option label="已确认" value="Y"></el-option>
              <el-option label="未确认" value="N"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" size="mini" icon="el-icon-search" @click="handleSearch">
              查询
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button v-permission="'live_guarantee_lock__lock'" v-if="!lock_info.id" type="primary" size="mini"
              icon="el-icon-lock" @click="lockYearMonth">
              锁定月份
            </el-button>
            <el-button v-permission="'live_guarantee_lock__unlock'" v-if="lock_info.id" type="success" size="mini"
              icon="el-icon-unlock" @click="unlockYearMonth">
              解锁月份
            </el-button>
          </el-form-item>
          <el-form-item>
            <export-btn v-permission="'ensure_income__export'" size="mini" :can-export="true" btn-type="warning"
              @export="handleExport('refExportBtn')" ref="refExportBtn" :lint-title="`导出`" />
          </el-form-item>
          <el-form-item>
            <el-button type="success" size="mini" icon="el-icon-message" @click="handleNotifyAgent"
              :disabled="selectedData.length === 0">
              通知经纪人
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="flex-align-center">
        <el-button icon="el-icon-refresh" title="点击更新数据" type="text" circle :disabled="doLoading" :loading="doLoading"
          @click="handleRunScript" style="padding:0;margin-right: 4px;" />
        <span title="最后更新时间" class="tip-time" v-if="tableData[0] && tableData[0].last_time">
          更新于：{{ tableData[0].last_time }}
        </span>
        <span v-else class="tip-time">暂无数据</span>
      </div>
    </div>
    <div style="height: calc(100% - 96px)">
      <el-table border :data="tableData" height="calc(100% - 16px)" @sort-change="eventSortMethod"
        @select-all="HandleSelectAll" @select="handleSelectRow">
        <el-table-column type="selection" width="55" />
        <el-table-column label="#" type="index" />
        <el-table-column label="核算归属月份" prop="date_check" sortable width="120">
          <template v-slot="{ row: { date_check } }">
            <b>{{ date_check | parseTime('{y}年{m}月') }}</b>
          </template>
        </el-table-column>
        <el-table-column label="红人名称" prop="nickname" show-overflow-tooltip width="130" />
        <el-table-column label="经纪人" prop="agent_name" show-overflow-tooltip width="90" />
        <el-table-column label="通知状态" prop="is_notify" show-overflow-tooltip width="90">
          <template v-slot="{ row: { is_notify } }">
            <div style="display: flex; align-items: center; gap: 4px;">
              <el-tag v-if="is_notify === 'Y'" type="success" size="mini">已通知</el-tag>
              <b v-else>未通知</b>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="确认状态" prop="is_confirm" show-overflow-tooltip width="90">
          <template v-slot="{ row: { is_confirm } }">
            <div style="display: flex; align-items: center; gap: 4px;">
              <el-tag v-if="is_confirm === 'Y'" type="success" size="mini">已确认</el-tag>
              <b v-else>未确认</b>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="confirm_type" label="确认类型" header-align="center" align="center" width="120" />
        <el-table-column label="平台" prop="platform" show-overflow-tooltip width="80" />
        <el-table-column label="保量进度" prop="stage_schedule" header-align="right" align="right" sortable width="120">
          <template v-slot="{ row: { stage_schedule } }">
            <div>{{ stage_schedule | numberFormat(2) }}%</div>
          </template>
        </el-table-column>
        <el-table-column label="可结算收入" prop="stage_amount" header-align="right" align="right" sortable width="120">
          <template v-slot="{ row: { stage_amount } }">
            <b>￥{{ stage_amount | numberFormat(2) }}</b>
          </template>
        </el-table-column>
        <el-table-column label="累计保量进度" prop="accrue_schedule" header-align="right" align="right" sortable width="120">
          <template v-slot="{ row: { accrue_schedule } }">
            <div>{{ accrue_schedule | numberFormat(2) }}%</div>
          </template>
        </el-table-column>
        <el-table-column label="累计可结算收入" prop="accrue_amount" header-align="right" align="right" sortable width="130">
          <template v-slot="{ row: { accrue_amount } }">
            <b>￥{{ accrue_amount | numberFormat(2) }}</b>
          </template>
        </el-table-column>
        <el-table-column label="分成比例" prop="artist_rate" header-align="right" align="right" sortable width="130">
          <template v-slot="{ row: { artist_rate } }">
            <b>￥{{ artist_rate | numberFormat(2) }}%</b>
          </template>
        </el-table-column>
        <el-table-column label="红人分成" prop="artist_rate_amount" header-align="right" align="right" sortable width="130">
          <template v-slot="{ row: { artist_rate_amount } }">
            <b>￥{{ artist_rate_amount | numberFormat(2) }}</b>
          </template>
        </el-table-column>
        <el-table-column label="公司收入" prop="company_rate_amount" header-align="right" align="right" width="130">
          <template v-slot="{ row: { company_rate_amount } }">
            <b>￥{{ company_rate_amount | numberFormat(2) }}</b>
          </template>
        </el-table-column>
        <el-table-column label="订单编号" algin="center" width="150">
          <template v-slot="{ row }">
            <to-order-detail by-field="order_no" :order="{ order_no: row.order_no }" />
          </template>
        </el-table-column>
        <el-table-column label="乙方名称" prop="company_name" show-overflow-tooltip />
        <el-table-column label="客户名称" prop="customer_name" show-overflow-tooltip width="130" />
        <el-table-column label="销售" prop="sale" show-overflow-tooltip />
        <el-table-column label="客户性质" prop="customer_nature" show-overflow-tooltip />
        <el-table-column label="品牌" prop="brand" show-overflow-tooltip />
        <el-table-column label="行业" prop="trade" show-overflow-tooltip />
        <el-table-column label="产品/内容" prop="product" show-overflow-tooltip />
        <el-table-column label="订单来源" prop="order_source" show-overflow-tooltip />
        <el-table-column label="客单" prop="passenger_order_interval" show-overflow-tooltip />
        <el-table-column label="品类" prop="product_category" show-overflow-tooltip />
        <el-table-column label="合作形式" prop="form_of_cooperation" show-overflow-tooltip />
        <el-table-column label="含税收入" prop="payment_account" show-overflow-tooltip />
        <el-table-column label="回款金额" prop="sum_amount" show-overflow-tooltip />
        <el-table-column label="应收款" prop="remain_account" show-overflow-tooltip />
        <el-table-column label="备注" prop="remark" show-overflow-tooltip />
        <el-table-column label="收款形式" prop="payment_method_alias" show-overflow-tooltip />
        <el-table-column label="合同归档" prop="contract_filed_alias" show-overflow-tooltip />
        <el-table-column label="合同编号" prop="contract_no" show-overflow-tooltip />
        <el-table-column label="合同金额" prop="contract_amount" show-overflow-tooltip />
        <el-table-column label="财务备注" prop="f_remark" show-overflow-tooltip />
        <el-table-column label="是否保次" prop="is_quantity_times_alias" show-overflow-tooltip />
        <el-table-column label="直播次数" prop="live_count" show-overflow-tooltip />
        <el-table-column label="是否保量" prop="is_quantity_alias" show-overflow-tooltip />
        <el-table-column label="保量金额" prop="gq_amount" show-overflow-tooltip />
        <el-table-column label="是否完结" prop="is_done_order" show-overflow-tooltip>
          <template v-slot="{ row: { is_done_order } }">
            {{ is_done_order == 0 ? '未完结' : '已完结' }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="created_at" show-overflow-tooltip />
      </el-table>
      <div>
        <el-row>
          <el-col :span="12">
            <div class="bottom-bar">
              <div
                style="cursor: pointer;font-size: 1rem;font-style: italic;margin-left: 10px;display: flex;align-items: center">
                <div style="font-weight: bold;display: flex">
                  <span style="margin-right: 10px;font-size: 1.2rem;line-height: 3.5">合计：</span>
                  <span style="margin-right: 10px;">可结算收入：
                    <span class="money" style="font-size: 1.2rem;line-height: 3.5">{{
                      moneyFormat(sum_amount)
                    }}（{{ moneyFormat(total_amount) }}）</span>
                  </span>
                  <span style="margin-right: 10px;">累计可结算收入：
                    <span class="money" style="font-size: 1.2rem;line-height: 3.5">{{
                      moneyFormat(sum_accrue_amount)
                    }}（{{ moneyFormat(total_accrue_amount) }}）</span>
                  </span>
                  <!--                  <span style="margin-right: 10px">可结算总收入：-->
                  <!--                    <span style="font-size: 1.2rem;line-height: 3.5">{{ moneyFormat(total_amount) }}</span>-->
                  <!--                  </span>-->
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="12" style="text-align: right">
            <el-pagination background :current-page="query.page" :page-sizes="[5, 10, 20, 100, 200, 300, 400]"
              :page-size="query.page_size" layout="total, sizes, prev, pager, next" :total="query.total"
              style="margin-top: 10px;float: right;" @current-change="handleCurrentChange"
              @size-change="eventSizeChange" />
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 通知经纪人弹框 -->
    <el-dialog title="通知经纪人" :visible.sync="notifyDialogVisible" width="800px" :close-on-click-modal="false">
      <el-table :data="selectedData" border style="width: 100%">
        <el-table-column prop="date_check" label="核算归属月份" width="120">
          <template slot-scope="scope">
            {{ formatDate(scope.row.date_check) }}
          </template>
        </el-table-column>
        <el-table-column prop="nickname" label="红人名称" width="130"></el-table-column>
        <el-table-column prop="agent_name" label="经纪人" width="90"></el-table-column>
        <el-table-column label="订单编号" align="right" width="120">
          <template v-slot="{ row }">
            <to-order-detail by-field="order_no" :order="{ order_no: row.order_no }"/>
          </template>
        </el-table-column>
        <el-table-column prop="artist_rate_amount" label="分成金额" width="120" align="right">
          <template slot-scope="scope">
            <b>￥{{ $utils.numberFormat(scope.row.artist_rate_amount || 0, 2) }} 元</b>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px; text-align: right; font-weight: bold;">
        总计分成金额：￥{{ moneyFormat(notifyTotalAmount) }}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="notifyDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmNotify" :loading="notifyLoading">确认通知</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ToOrderDetail from "@/views/adOrder/components/ToDetail.vue";
import {ensureIncomeExportList, ensureIncomeList, notifyAgent} from "@/api/incomeSummary";
import { runReportOrderLiveScript } from "@/api/order";

import moment from "moment";
import { copy } from "@/utils";
import { liveGuaranteeLockGetInfo, liveGuaranteeLockSetLock, liveGuaranteeLockSetUnlock } from "@/api/liveGuaranteeLock";
import ExportBtn from "@/components/export/ExportBtn.vue";
import SelectArtist from "@/components/Selects/artist.vue";
import CompanySelect from "@/views/adOrder/components/companySelect.vue";

export default {
  components: { CompanySelect, SelectArtist, ExportBtn, ToOrderDetail },
  props: {
    readonly: Boolean,
    // selectedData: {
    //   type: Array,
    //   default() {
    //     return []
    //   }
    // },
  },
  data() {
    return {
      copy,
      selectedData: [],
      tableData: [],
      loading: false,
      doLoading: false,
      query: {
        page: 1,
        page_size: 20,
        total: 0,
        type: 'money',
        order_by: null,
        is_notify: null,
        agent_name: null,
        is_confirm: null,
        date_check: null,
        artist_id: null,
        company_id: null,
        date_range: []
      },
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick(picker) {
            picker.$emit('pick', [new Date(), new Date()]);
          }
        }, {
          text: '今年至今',
          onClick(picker) {
            const end = new Date();
            const start = new Date(new Date().getFullYear(), 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近六个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 6);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      lock_info: {
        id: null,
        curr_lock_at: ''
      },
      total_amount: 0,
      sum_amount: 0,
      total_accrue_amount: 0,
      sum_accrue_amount: 0,
      // 通知经纪人相关
      notifyDialogVisible: false,
      notifyLoading: false,
      notifyForm: {
        date_check: '',
        nickname: '',
        agent_name: '',
        artist_rate_amount: ''
      }
    }
  },
  computed: {
    // 计算通知总金额
    notifyTotalAmount() {
      if (!this.selectedData || this.selectedData.length === 0) {
        return 0;
      }
      return this.selectedData.reduce((total, item) => {
        return total + (parseFloat(item.artist_rate_amount) || 0);
      }, 0);
    }
  },
  // watch: {
  //   'selectedData.length': function (val) {
  //     if (val === 0) {
  //       // this.moneyFormat(0)
  //       this.sum_amount = 0
  //       this.sum_accrue_amount = 0
  //     } else {
  //       this.sumAmount();
  //       this.sumAccrueAmount();
  //     }
  //   }
  // },
  created() {
    this.query.date_check = moment().subtract(1, 'month').format('YYYY-MM');
    this.getTableData(true)
  },
  methods: {
    eventSizeChange: function (page_size) {
      this.query.page_size = page_size
      this.handleSearch()
    },
    eventSortMethod: function ({ order, prop }) {
      let string = null;
      switch (order) {
        case 'descending':
          string = `${prop} desc`
          break;
        case 'ascending':
          string = `${prop} asc`
          break;
        default:
          break;
      }
      this.query.order_by = string
      this.getTableData(true)
    },
    handleSearch: function () {
      this.getTableData(true)
    },
    async handleRunScript() {
      let year = moment().format('YYYY')
      let month = moment().format('MM')
      if (this.query.date_check) {
        year = moment(this.query.date_check).format('YYYY')
        month = moment(this.query.date_check).format('MM')
      }

      //执行权限更新
      const string_s = `${year}年${month}月`;
      this.$confirm(
        `确定更新<b>${string_s}</b>数据吗？`,
        '数据更新',
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(async () => {
          this.doLoading = true

          await runReportOrderLiveScript([{ year, month }])
          this.msgSuccess('更新任务已发布，请稍后点击查询是否更新')

          setTimeout(() => {
            this.doLoading = false
          }, 500)
        })
    },
    handleExport: async function () {
      try {
        this.getSearch()
        const response = await ensureIncomeExportList(this.query)
        this.$refs.refExportBtn.exportSaveXlsx(response, '全案保量汇总导出')
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
      }
    },
    // 通知经纪人
    handleNotifyAgent() {
      if (this.selectedData.length === 0) {
        this.$message.warning('请先选择要通知的数据')
        return
      }
      this.notifyDialogVisible = true
    },
    // 确认通知
    async confirmNotify() {
      this.notifyLoading = true
      try {
        // 构建通知数据，格式为 {ids: ids, type: type}
        const ids = this.selectedData.map(item => item.l_g_id)
        const notifyData = {
          ids: ids,
          type: 'ensure_income'
        }

        await notifyAgent(notifyData)
        this.$message.success({
          message:'通知发送成功',
          showClose:true
        })
        this.notifyDialogVisible = false
        // 刷新列表数据
        this.getTableData()
      } catch (error) {
        this.$message.error('通知发送失败：' + (error.message || '未知错误'))
      } finally {
        this.notifyLoading = false
      }
    },
    handleCurrentChange: function (page) {
      this.query.page = page
      this.getTableData()
    },
    getSearch: function () {
      this.query.date_check = this.query.date_check ? moment(this.query.date_check).format('YYYY-MM') + '-01' : null

      return this.query
    },
    getTableData: async function (is_search = false) {
      this.sum_amount = 0;
      this.sum_accrue_amount = 0;
      this.selectedData = []
      // 获取锁定信息
      this.getLockInfo()
      // 查询重置 page
      if (is_search) {
        this.query.page = 1
        this.total_amount = 0;
      }
      this.getSearch()
      this.loading = true
      const { success, model } = await ensureIncomeList(this.query)
      this.loading = false
      if (!success) {
        return;
      }
      const { data, total, sum_amount, sum_accrue_amount } = model
      this.tableData = data || []
      this.query.total = total || 0
      this.total_amount = sum_amount || 0
      this.total_accrue_amount = sum_accrue_amount || 0
    },
    changeTableSort(_) {
      const { prop, order } = _
      let order_by = null
      if (order) {
        order_by = order === 'ascending' ? `\`${prop}\` asc` : `\`${prop}\` desc`
      }
      this.queryParams.order_by = order_by
      this.getTableData()
    },
    getLockInfo: async function () {
      const { model: { info } } = await liveGuaranteeLockGetInfo(this.query.date_check)
      this.lock_info = info !== null ? info : { id: null }
      this.lock_info.curr_lock_at = this.lock_info.id !== null ? this.query.date_check : ''
    },
    lockYearMonth: async function () {
      this.$confirm('是否确认锁定当月数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        if (!this.query.date_check) {
          this.msgError('请选择月份')
          return false
        }
        const { code, message } = await liveGuaranteeLockSetLock(this.query.date_check)
        if (code !== 100000) {
          this.msgError(message)
          return false
        }
        this.msgSuccess('月份锁定成功')
        this.getLockInfo()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    unlockYearMonth: async function () {
      this.$confirm('是否确认解锁当月数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        if (this.lock_info.id !== null) {
          const { code, message } = await liveGuaranteeLockSetUnlock(this.lock_info.curr_lock_at)
          if (code !== 100000) {
            this.msgError(message)
            return false
          }
          this.msgSuccess('月份解锁成功')
          this.getLockInfo()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // //计算总含税收入
    sumAmount() {
      let total = 0;
      this.selectedData.map((item) => {
        total += item.stage_amount / 1
      })
      this.sum_amount = total
    },
    // //计算总含税收入
    sumAccrueAmount() {
      let total = 0;
      this.selectedData.map((item) => {
        total += item.accrue_amount / 1
      })
      this.sum_accrue_amount = total
    },
    //预览数据-清空
    clearData() {
      // this.pageSelectedList = []
      this.selectedData = [];
      // 重置合计
      this.sum_amount = 0;
      this.sum_accrue_amount = 0;
      // this.$refs['refTableAdOrder'].handleClearSelection()
    },
    //当选择项发生变化时会触发该事件
    HandleSelectAll(selection) {
      // console.log(selection)
      if (selection.length === 0) {
        //取消全选
        // console.log('取消全选')
        // 取消的数据对象 tableData
        this.tableData.forEach((row) => {
          let index = this.selectedData.findIndex(value => value.l_g_id === row.l_g_id)
          if (index > -1)
            this.selectedData.splice(index, 1)
        })
      } else {
        selection.map((row) => {
          let index = this.selectedData.findIndex(value => value.l_g_id === row.l_g_id)
          index === -1 && this.selectedData.push(row)
        })
      }
      // 计算可结算收入合计
      this.sumAmount();
      this.sumAccrueAmount();
    },
    // // 行选中、取消选中
    handleSelectRow(selection, row) {
      if (selection.indexOf(row) === -1) {
        // console.log('取消选中')
        let index = this.selectedData.findIndex(value => value.l_g_id === row.l_g_id)
        // this.$notify.info(`取消第${index}行`)
        if (index > -1)
          this.selectedData.splice(index, 1)
      } else {
        this.selectedData.push(row)
      }
      // 计算可结算收入合计
      this.sumAmount();
      this.sumAccrueAmount();
    },
    moneyFormat(val) {
      return this.$utils.numberFormat(val, 2)
    },
    // 格式化日期
    formatDate(date) {
      if (!date) return '';
      return moment(date).format('YYYY年MM月');
    },
  }
}
</script>

<style lang="scss">
.ensure-income-list-container {
  padding: 5px 10px;
  height: calc(100vh - 166px);

  .el-table .red-row {
    background: #ffeeee;
  }

  .el-table thead tr,
  .el-table thead th {
    background: white !important;
    color: #3c3c3c !important;
    font-weight: 600;
  }

  .flag-error {
    display: inline-block;
    width: auto;
    line-height: 17px;
    padding: 0 10px;
    border-radius: 9px;
    //border: 1px solid #ab0707;
    color: #FFFFFF;
    background-color: #ab0707;
    font-size: 12px;
    cursor: pointer;
  }

  .head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1px!important;

    .el-select {
      //width: 250px;
      margin-right: 12px;
    }
  }

  .ape-table-container {
    height: calc(100% - 206px) !important;
  }

  .tip-time {
    color: #8a8e99;
    font-size: 12px;
    margin-right: 10px;
  }

  .tip-help {
    margin-top: 40px;
    margin-bottom: 10px;
    padding: 8px 24px;
    overflow-y: auto;
    background-color: #FFF9FBFC;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    line-height: 22px;
    color: #666;
    border-radius: 9px;
    position: relative;
    box-sizing: border-box;
    height: 110px;
  }

  .tag {
    border-radius: 3px;
    background-color: #ffeef3;
    color: #fe346e;
    font-size: 12px;
    padding: 0 8px;
    height: 20px;
    line-height: 20px;
  }


  .el-table .cell {
    height: auto !important;
  }

  .el-table th.el-table__cell>.cell {
    min-height: 34px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .el-table .sort-caret.ascending {
    top: 7px !important;
  }

  .el-table .sort-caret.descending {
    bottom: 5px !important;
  }

  .over-hidden {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .live-sm:hover {
    .live-sm__mark {
      opacity: .7 !important;
    }
  }

  .live-sm {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    position: relative;
    cursor: pointer;

    &__mark {
      position: absolute;
      width: 100%;
      height: 100%;
      background: #111;
      opacity: 0;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 4px;

      span {
        color: #FFFFFF;
        cursor: pointer;
      }
    }
  }
}
</style>
